module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    class: {
      'full-sized-style': _vm.isFullSized()
    }
  }, [(!_vm.widget.iframe) ? _c('div', {
    staticClass: "col-sm-12 no-widget-padding",
    domProps: {
      "innerHTML": _vm._s(_vm.widget.html)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.widget.iframe) ? _c('iframe', {
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "id": "contentIframe",
      "src": 'data:text/html;charset=utf-8,' + _vm.widget.html,
      "width": "100%",
      "height": "100%",
      "frameBorder": "0",
      "scrolling": "no"
    },
    on: {
      "load": function($event) {
        _vm.iframeLoaded()
      }
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4657a085","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/main/components/pages/page/widgets/HtmlWidget.vue
// module id = 111
// module chunks = 0 1 2